export default __webpack_public_path__ + "static/media/yellow_rocket.a264cd71.png";